export default __webpack_public_path__ + "static/media/overdueTaskIcon.4092db3e.svg";